var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"data-list-container",attrs:{"id":"contacts-table"}},[_c('tc-table',{ref:"table",attrs:{"dataList":_vm.contacts,"tbody":_vm.tbody,"settings":{
      externalFilters: {
        show: false
      },
      defaultDate: null,
      filters: {
        hosts: {
          type: 'checkbox',
          class: 'min-w-48',
          label: 'Only Show Hosts'
        },
        contactType: {
          type: 'v-select',
          class: 'min-w-48',
          label: 'Type',
          clearable: false,
          options: {
            text: 'name',
            value: 'id',
            items: [{
              id: '',
              name: 'All'
            } ].concat( ((_vm.contactTypes || {}).items || []))
          }
        },
        status: {
          type: 'v-select',
          class: 'min-w-48',
          label: 'Status',
          clearable: false,
          options: {
            text: 'name',
            value: 'id',
            items: [{
              id: '',
              name: 'All'
            }, {
              id: 'checkedin',
              name: 'Signed In'
            }, {
              id: 'checkedout',
              name: 'Signed Out'
            }]
          }
        },
      }
    }},on:{"filter":_vm.filter}},[_c('template',{slot:"thead"},[_c('vs-th',{attrs:{"sort-key":"name"}},[_vm._v("Status")]),_c('vs-th',{attrs:{"sort-key":"category"}},[_vm._v("Visitor Name")]),_c('vs-th',{attrs:{"sort-key":"category"}},[_vm._v("Type")]),_c('vs-th',{attrs:{"sort-key":"category"}},[_vm._v("Phone")]),_c('vs-th',{attrs:{"sort-key":"category"}},[_vm._v("Email")]),_c('vs-th',{attrs:{"sort-key":"category"}},[_vm._v("Company")]),_c('vs-th',[_vm._v("Actions")])],1)],2),_c('vs-button',{staticClass:"mr-auto mb-2",staticStyle:{"margin-top":"-2rem"},attrs:{"icon-pack":"feather","icon":"icon-plus","icon-before":""},on:{"click":_vm.openFormContact}},[_vm._v("Add Contact")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }